<template>
    <div v-loading="loading">
        <div style="display: flex;justify-content: space-between;margin-bottom: 10px;padding: 0 10px">
            <b style="line-height: 28px">{{ title }}
                <el-tooltip content="下载" placement="top">
                    <div style="display: inline-block;position: relative;margin-left: 10px;cursor: pointer" @click="downloadZip" :disabled="downloading">
                        <el-icon v-if="downloading" style="font-size: 18px; animation: rotating 1.5s linear infinite;">
                            <Loading/>
                        </el-icon>
                        <el-icon v-else style="font-size: 18px;">
                            <Download/>
                        </el-icon>
                    </div>
                </el-tooltip>
                <el-tooltip content="复制表格到剪贴板" placement="top">
                    <el-icon style="cursor: pointer;margin-left: 10px" @click="copyTable">
                        <DocumentCopy/>
                    </el-icon>
                </el-tooltip>
            </b>
        </div>
        <slot name="header"></slot>
        <el-table :data="data" :id="id" ref="table" :border="border" :style="{width}" @sort-change="sortChange"
                  :height="height" :show-summary="showSummary" :span-method="spanMethod" :cell-style="cellStyle"
                  :summary-method="summaryMethod" :row-class-name="rowClassName" :default-sort="defaultSort">
            <slot></slot>
        </el-table>
        <el-table :data="complete || data" id="complete" ref="complete_table" :border="border" :style="{width}"
                  @sort-change="sortChange" :show-summary="showSummary" :span-method="spanMethod"
                  :cell-style="cellStyle" :summary-method="summaryMethod" :row-class-name="rowClassName"
                  :default-sort="defaultSort" v-show="false">
            <template v-for="node in $slots.default()">
                <component :is="node" v-if="node.props && node.props['download-hide']===undefined"></component>
            </template>
        </el-table>
    </div>
</template>

<script>
import { copyTable } from '../libs/utils';
import {downloadResourcesAsZip} from '../libs/downloadUtils';

export default {
    name: "DownloadableTable",
    props: {
        id: {
            type: String,
            default: 'table',
        },
        title: String,
        data: Array,
        loading: Boolean,
        tips: String,
        border: Boolean,
        showSummary: Boolean,
        spanMethod: Function,
        cellStyle: Object,
        summaryMethod: Function,
        rowClassName: String,
        defaultSort: Function,
        width: String,
        complete: Array,
        height: [String, Number],
    },
    data() {
        return {
            selected: [], columns: [], downloading: false,
        }
    },
    methods: {
        downloadZip() {
            this.downloading = true;
            downloadResourcesAsZip(this.data, this.title, {
                baseUrl: import.meta.env.VITE_CDN_URL,
            }).then(() => {
                this.downloading = false;
                this.$message.success('下载完成');
            }).catch(() => {
                this.downloading = false;
                this.$message.error('下载失败');
            })
            
        },
        copyTable() {
            if (!this.data || this.data.length < 1)
                return
            if (this.complete) {
                copyTable(this.$refs.complete_table.$refs.bodyWrapper.parentElement);
            } else {
                copyTable(this.$refs.table.$refs.bodyWrapper.parentElement);
            }
        },
        sort(prop, order) {
            this.$refs.table.sort(prop, order)
        },
        sortChange({column, prop, order}) {
            this.$emit('sort-change', {column, prop, order})
        },
    },
}
</script>

<style scoped>
@keyframes rotating {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}
</style>
